import { render, staticRenderFns } from "./_live-status.vue?vue&type=template&id=23a7ec1c&scoped=true"
import script from "./_live-status.vue?vue&type=script&lang=js"
export * from "./_live-status.vue?vue&type=script&lang=js"
import style0 from "./_live-status.vue?vue&type=style&index=0&id=23a7ec1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7ec1c",
  null
  
)

export default component.exports